import { render, staticRenderFns } from "./Shimmer.vue?vue&type=template&id=2c0bb91f&scoped=true"
import script from "./Shimmer.vue?vue&type=script&lang=js"
export * from "./Shimmer.vue?vue&type=script&lang=js"
import style0 from "./Shimmer.vue?vue&type=style&index=0&id=2c0bb91f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0bb91f",
  null
  
)

export default component.exports